import { Core } from "@faire/design-tokens";
import { Button, ButtonProps } from "@faire/web--source/slate/Button";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";

export const SubmitButton: React.FC<ButtonProps> = (props) => {
  return (
    <StyledButton variant="primary" type="submit" {...props}>
      <Typography color={Core.surface.inverse}>
        <StrictLocalMsg
          defaultMessage="Submit"
          description={{
            text: "Submit button for the CSAT form",
            img: "https://cdn.faire.com/fastly/888cc62e16f087c8fa83df3edafe6ab6f6f83ef2f69c7529f03a0765e7c4a0f6.png",
          }}
        />
      </Typography>
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  margin-top: ${getSpacing("1x")};
  margin-bottom: ${getSpacing("5x")};
`;
